import { defineStore } from 'pinia'
import { fetchListWithChildren } from '@/api/category'
import { fetchList as fetchBranchList } from '@/api/branch'
import { fetchListWithChildren as fetchCashCategoryList } from '@/api/cash_category'
import { fetchCashAccList } from '@/api/cash_acc_info'
import { fetchDefaultSkuList } from '@/api/inventory'
import { fetchList as fetchAttributeList } from '@/api/attributeCategory'
import { fetchPrinterList } from '@/api/printer'

const getDefaultShopData = () => ({
  categories: [],
  branches: [],
  cashCategories: [],
  cashAccs: [],
  defaultSkuList: [],
  attributes: [],
  printers: [],
  selectedBranch: null,
  selectedPrinter: null,
  discountAcc: null,
  discountCashCategory: null,
  returnInAcc: null
})

export const useShopDataStore = defineStore('shopData', {
  state: getDefaultShopData,

  actions: {
    async InitShopData() {
      await Promise.all([
        this.GetCategories(),
        this.GetBranches(),
        this.GetCashCategories(),
        this.GetCashAccs(),
        this.GetDefaultSkuList(),
        this.GetAttributes(),
        this.GetPrinters()
      ])
    },

    async GetCategories() {
      if (this.categories?.length > 0) return
      const res = await fetchListWithChildren()
      this.categories = res.data
    },

    async GetBranches() {
      if (this.branches?.length > 0) return
      const res = await fetchBranchList()
      this.branches = res.data.list
    },

    async GetCashCategories() {
      if (this.cashCategories?.length > 0) return
      const res = await fetchCashCategoryList()
      this.cashCategories = res.data.filter(e => e.name.toLowerCase() !== 'discount')
      this.discountCashCategory = res.data.find(e => e.name.toLowerCase() === 'discount')
    },

    async GetCashAccs() {
      if (this.cashAccs?.length > 0) return
      const res = await fetchCashAccList({ pageNum: 1, pageSize: 1000, keyword: null })
      this.cashAccs = res.data.list?.filter(e => !['discount', 'return in'].includes(e.name.toLowerCase()))
      this.discountAcc = res.data.list?.find(e => e.name.toLowerCase() === 'discount')
      this.returnInAcc = res.data.list?.find(e => e.name.toLowerCase() === 'return in')
    },

    async GetDefaultSkuList() {
      if (this.defaultSkuList?.length > 0) return
      const res = await fetchDefaultSkuList({ pageNum: 1, pageSize: 1000, keyword: null })
      this.defaultSkuList = res.data
    },

    async GetAttributes() {
      if (this.attributes?.length > 0) return
      const res = await fetchAttributeList({ pageNum: 1, pageSize: 1000, keyword: null })
      this.attributes = res.data.list
    },

    async GetPrinters() {
      if (this.printers?.length > 0) return
      const res = await fetchPrinterList()
      this.printers = res.data
    },

    SetSelectedBranch(branch) {
      this.selectedBranch = branch
    },

    SetSelectedPrinter(printer) {
      this.selectedPrinter = printer
    }
  }
})
